// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__ATCus","text":"styles_text__RCTwt","success":"styles_success__9xCXu"};